<template>
  <div class="ct-right-container mt-2">
    <div
      v-if="addNewField"
      class="
        h-100
        w-100
        d-flex
        flex-column
        align-items-center
        justify-content-center
      "
    >
      <div><img src="../../assets/customfield/addnew.svg" alt="" /></div>
      <div class="cs-bold-txt mt-4">Add New Fields</div>
      <div class="cf-light-txt text-center mt-2">
        Select/Create entry fields according to your <br />
        organizational requirements
      </div>
      <div v-if="roles.includes('PUT_FORM')" class="bluebtn">
        <b-button
          :disabled="predefinedFields.length == 0"
          @click="
            (predefinedField = true),
              (addNewField = false),
              clearData(),
              (labelExists = false),
              (labelPreExists = false)
          "
          class="acs-addBtn-modal mt-4 width-169"
          >Pre-defined Fields</b-button
        >
      </div>
      <div v-if="roles.includes('PUT_FORM')" class="bluebtn">
        <b-button
          @click="
            (predefinedField = false),
              (addNewField = false),
              clearData(),
              (labelExists = false),
              (labelPreExists = false)
          "
          class="acs-cancelBtn-modal mt-3 width-169"
          >Custom Fields</b-button
        >
      </div>
    </div>
    <div v-else>
      <div class="d-flex align-items-center border-bottom padding-12-15">
        <img
          @click="(predefinedField = false), (addNewField = true), clearData()"
          class="mr-3 pointer"
          src="../../assets/customfield/blueBackArrow.svg"
          alt=""
        />
        <span class="cs-bold-txt">{{
          editField ? "Edit Field" : "Add New Field"
        }}</span>
      </div>
      <div v-if="predefinedField" class="cs-body">
        <div class="cs-bold-txt-2">Predefined Field</div>
        <div class="cf-light-txt mt-1">
          Select pre-configured fields from the dropdown below
        </div>
        <!-- OPTIONS DROPDOWN -->
        <div class="position-relative">
          <div
            :style="
              editField &&
              'cursor: not-allowed; background: #D0D5DD !important;'
            "
            :class="{ redError: $v.predefined.selectedField.$error }"
            ref="opendrop"
            @click="
              !editField ? (predefinedDropdown = !predefinedDropdown) : ''
            "
            class="cs-dropdown-field mt-4 pointer"
          >
            <div class="w-94 text-truncate">
              <span
                v-if="!predefined.selectedField"
                class="acs-filter-dropdown-place"
                >Select</span
              >
              <span v-else class="cs-dropdown-sel-txt">{{
                predefined.selectedField && predefined.selectedField.label
              }}</span>
            </div>
            <img
              v-if="editField"
              src="../../assets/customfield/disabledarrow.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
              alt=""
            />
          </div>
          <b-collapse
            ref="predefineddrop"
            v-closable="{
              exclude: ['predefineddrop', 'opendrop'],
              handler: 'hidePredefinedDropdown',
            }"
            v-model="predefinedDropdown"
            class="cs-dropdown"
          >
            <div
              @click="
                (predefined.selectedField = field), (predefinedDropdown = false)
              "
              v-for="field in predefinedFields"
              :key="field.key"
              class="
                cs-options
                d-flex
                align-items-center
                justify-content-between
                pointer
              "
              :class="
                predefined.selectedField &&
                predefined.selectedField.label == field.label &&
                'cs-options-selected'
              "
            >
              <div>{{ field.label }}</div>
              <div class="cs-tag">{{ capitalize(field.controlType) }}</div>
            </div>
          </b-collapse>
        </div>
        <div
          class="errortxt position-absolute"
          v-if="$v.predefined.selectedField.$error"
        >
          Required
        </div>
        <!-- PLACEHOLDER TEXT -->
        <div
          v-if="
            predefined.selectedField != null &&
            predefined.selectedField.controlType != 'boolean' &&
            predefined.selectedField.controlType != 'upload_file'
          "
          class="position-relative mt-3"
        >
          <div class="d-flex align-items-center justify-content-between">
            <div class="acs-input-head">
              Placeholder Text<span class="asterik">*</span>
            </div>
            <div
              class="cs-greyshadow position-relative"
              @mouseenter="showTooltipPlace = true"
              @mouseleave="showTooltipPlace = false"
            >
              <img src="../../assets/customfield/greyI.svg" alt="" />
              <div v-if="showTooltipPlace" class="cs-tooltip-place">
                <div class="text-center">
                  <img src="../../assets/customfield/tooltipImg.svg" alt="" />
                </div>
                <div class="mt-1">
                  The placeholder text should indicate<br />
                  to the user what type of data is<br />
                  expected in the field.
                </div>
              </div>
            </div>
          </div>
          <div class="mt-1">
            <b-form-input
              @keyup.enter="addField('predefinedField')"
              v-model.trim="$v.predefined.placeholder.$model"
              class="cs-laptopinput"
              id="input-1"
              placeholder="e.g. Enter Experience"
              :class="{ redError: $v.predefined.placeholder.$error }"
            >
            </b-form-input>
          </div>
          <div
            class="errortxt position-absolute"
            v-if="$v.predefined.placeholder.$error"
          >
            Required
          </div>
        </div>
        <!-- FIELD CHARECTER LIMIT -->
        <!-- <div class="position-relative mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="acs-input-head">
              Field Char Limit<span class="asterik">*</span>
            </div>
            <div
              class="cs-greyshadow position-relative"
              @mouseenter="showTooltipLimit = true"
              @mouseleave="showTooltipLimit = false"
            >
              <img src="../../assets/customfield/greyI.svg" alt="" />
              <div v-if="showTooltipLimit" class="cs-tooltip-place">
                <div class="mt-1">
                  Set the maximum number of<br />
                  characters allowed for this field
                </div>
              </div>
            </div>
          </div>
          <div class="mt-1">
            <b-form-input
              type="number"
              :class="{ redError: $v.predefined.limit.$error }"
              v-model="$v.predefined.limit.$model"
              min="1"
              class="cs-laptopinput"
              id="input-1"
              placeholder="e.g. 105"
            >
            </b-form-input>
          </div>
        </div>
        <div
          class="errortxt position-absolute"
          v-if="$v.predefined.limit.$error"
        >
          Required
        </div> -->
        <div
          v-if="
            predefined.selectedField != null &&
            predefined.selectedField.controlType != 'boolean'
          "
        >
          <div class="mt-3 cs-checkbox">
            <b-form-checkbox v-model="predefined.mandatory"
              >Required</b-form-checkbox
            >
          </div>
          <div class="cf-light-txt ml-4">
            Set the field to be required or optional
          </div>
        </div>
      </div>

      <div v-else-if="!addNewField" class="cs-body" ref="scrollContainer">
        <div class="cs-bold-txt-2">Custom Field</div>
        <div class="cf-light-txt mt-1">
          Create new Fields with available types for your custom needs
        </div>
        <!-- FIELD NAME -->
        <div class="position-relative mt-3">
          <div class="acs-input-head">
            Field Name<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-input
              @input="checkExists"
              @keyup.enter="addField('customField')"
              class="cs-laptopinput"
              id="input-1"
              v-model.trim="$v.customField.label.$model"
              placeholder="e.g. Enter Experience"
              :class="{
                redError:
                  $v.customField.label.$error || labelExists || labelPreExists,
              }"
            >
            </b-form-input>
          </div>

          <div
            class="errortxt position-absolute"
            v-if="$v.customField.label.$error"
          >
            Required
          </div>
          <div class="errortxt position-absolute" v-else-if="labelExists">
            Field Name already exists
          </div>
          <div class="errortxt position-absolute" v-else-if="labelPreExists">
            Field Name already exists in pre-defined field
          </div>
        </div>
        <!-- FIELD TYPE -->
        <div class="position-relative mt-3 pointer">
          <div class="acs-input-head">
            Field Type<span class="asterik">*</span>
          </div>
          <div
            ref="opencontroldrop"
            :class="{ redError: $v.customField.controlType.$error }"
            @click="!editField && (controlTypeDropdown = !controlTypeDropdown)"
            class="cs-dropdown-field mt-1"
            :style="
              editField &&
              'cursor: not-allowed;  background: #D0D5DD !important;'
            "
          >
            <div class="w-94 text-truncate">
              <span
                v-if="!customField.controlType"
                class="acs-filter-dropdown-place"
                >Select</span
              >
              <span v-else class="cs-dropdown-sel-txt">
                <img class="mr-2" :src="customField.controlType.svg" alt="" />
                {{ customField.controlType.text }}</span
              >
            </div>
            <img
              v-if="editField"
              src="../../assets/customfield/disabledarrow.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
              alt=""
            />
          </div>
          <b-collapse
            ref="controlTypeDrop"
            v-closable="{
              exclude: ['controlTypeDrop', 'opencontroldrop'],
              handler: 'hideControlDropdown',
            }"
            v-model="controlTypeDropdown"
            class="cs-dropdown maxHei-500 top-56"
          >
            <div
              @click="
                (customField.controlType = item), (controlTypeDropdown = false)
              "
              v-for="(item, index) in itemsArray"
              :key="index"
              :class="customField.controlType == item && 'cs-options-selected'"
              class="cs-options d-flex align-items-center pointer"
            >
              <img class="mr-2" :src="item.svg" alt="SVG Image" />
              <span class="acs-input-head">{{ item.text }}</span>
            </div>
          </b-collapse>
          <div
            class="errortxt position-absolute"
            v-if="$v.customField.controlType.$error"
          >
            Required
          </div>
        </div>

        <!-- DROPDOWN OPTIONS -->
        <div v-if="showDropdown" class="position-relative mt-3">
          <div class="acs-input-head mb-1">
            Add Dropdown Options<span class="asterik">*</span>
          </div>
          <draggable v-model="customField.values" group="lists">
            <div
              v-for="i in customField.values"
              :key="i.key"
              class="
                d-flex
                align-items-center
                justify-content-between
                w-100
                h-39
              "
              :class="
                (($v.customField.values.label.$error && !i.label) ||
                  (i.label && optionExists[i.key])) &&
                'mb-3'
              "
            >
              <div class="mr-1">
                <img src="../../assets/customfield/dragndrop.svg" alt="" />
              </div>
              <div class="w-64 mr-2">
                <b-form-input
                  @keyup.enter="addField('customField')"
                  v-model.trim="i.label"
                  @input="checkOptionExists()"
                  class="cs-laptopinput"
                  id="input-1"
                  :class="{
                    redError:
                      ($v.customField.values.label.$error && !i.label) ||
                      (i.label && optionExists[i.key]),
                  }"
                  placeholder="e.g. 105"
                >
                </b-form-input>

                <div
                  class="errortxt position-absolute"
                  v-if="$v.customField.values.label.$error && !i.label"
                >
                  Required
                </div>
                <div
                  class="errortxt position-absolute"
                  v-else-if="i.label && optionExists[i.key]"
                >
                  Option value already exists
                </div>
              </div>
              <div class="mt-3 cs-checkbox-2 d-flex align-items-center">
                <b-form-checkbox
                  @change="
                    customField.controlType.value == 'single_select' &&
                      changeDefaultValues(i.key, i.isDefault)
                  "
                  v-model="i.isDefault"
                  size="sm"
                  >Default</b-form-checkbox
                >
              </div>

              <div v-if="customField.values.length > 1" class="cs-line"></div>
              <div class="pointer">
                <img
                  v-if="customField.values.length > 1"
                  @click="
                    customField.values.length > 1 &&
                      (removeFromDropdown(i), checkOptionExists())
                  "
                  src="../../assets/customfield/optionDel.svg"
                  alt=""
                />
              </div>
            </div>
          </draggable>
          <div class="d-flex align-items-center justify-content-end mt-2">
            <div
              @click="addDropdown()"
              class="
                d-flex
                align-items-center
                justify-content-end
                cs-bluetxt
                mr-1
                pointer
              "
            >
              <img
                class="mr-2"
                src="../../assets/customfield/blueAdd.svg"
                alt=""
              />Add Option
            </div>
          </div>
        </div>
        <!-- DATE FORMAT DROPDOWN -->
        <div v-if="showDateFormat" class="position-relative mt-3 pointer">
          <div class="acs-input-head">
            Define Format<span class="asterik">*</span>
          </div>
          <div
            ref="opendatefornatdrop"
            :class="{ redError: $v.customField.dateTimeFormat.$error }"
            @click="defineformatDrop = !defineformatDrop"
            class="cs-dropdown-field mt-1"
          >
            <div class="w-94 text-truncate">
              <span
                v-if="Object.keys(customField.dateTimeFormat) == 0"
                class="acs-filter-dropdown-place"
                >Select</span
              >
              <span v-else class="cs-dropdown-sel-txt">{{
                customField.dateTimeFormat.label
              }}</span>
            </div>
            <img
              src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
              alt=""
            />
          </div>
          <b-collapse
            ref="dateFormatDrop"
            v-closable="{
              exclude: ['dateFormatDrop', 'opendatefornatdrop'],
              handler: 'hideDateFormatDropdown',
            }"
            v-model="defineformatDrop"
            class="cs-dropdown maxHei-500 top-56"
          >
            <div
              :class="customField.dateTimeFormat == i && 'cs-options-selected'"
              @click="
                (customField.dateTimeFormat = i), (defineformatDrop = false)
              "
              v-for="i in dateFormatData"
              :key="i.value"
              class="cs-options"
            >
              {{ i.label }}
            </div>
          </b-collapse>
          <div
            class="errortxt position-absolute"
            v-if="$v.customField.dateTimeFormat.$error"
          >
            Required
          </div>
        </div>

        <!-- REQUIRED CHECKBOX -->
        <div
          v-if="
            customField.controlType &&
            customField.controlType.value != 'boolean'
          "
          class="mt-3 cs-checkbox"
        >
          <b-form-checkbox v-model="customField.mandatory"
            >Required</b-form-checkbox
          >
        </div>
        <div
          v-if="
            customField.controlType &&
            customField.controlType.value != 'boolean'
          "
          class="cf-light-txt ml-4"
        >
          Set the field to be required or optional
        </div>
        <!-- FILE FORMAT -->
        <div v-if="showFileSizeLimit" class="position-relative mt-3 pointer">
          <div class="acs-input-head">
            File Format<span class="asterik">*</span>
          </div>
          <div
            ref="fileFormatOpen"
            :class="{ redError: $v.customField.fileFormat.$error }"
            @click="definefileformatDrop = !definefileformatDrop"
            class="cs-dropdown-field mt-1"
          >
            <div class="w-94 text-truncate">
              <span
                v-if="customField.fileFormat.length == 0"
                class="acs-filter-dropdown-place"
                >Select</span
              >
              <span
                v-else
                class="cs-dropdown-sel-txt"
                v-b-tooltip.hover.bottom="
                  getSelectedFormatLabels(customField.fileFormat)
                "
              >
                {{ getSelectedFormatLabels(customField.fileFormat) }}
                <!-- {{ customField.fileFormat.join(" + ") }} -->
              </span>
            </div>
            <img
              src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
              alt=""
            />
          </div>
          <b-collapse
            ref="fileFormatDrop"
            v-closable="{
              exclude: ['fileFormatDrop', 'fileFormatOpen'],
              handler: 'hideFileFormatDropdown',
            }"
            v-model="definefileformatDrop"
            class="cs-dropdown maxHei-500 top-56"
          >
            <div v-for="key in Object.keys(fileFormatData)" :key="key">
              <div class="cf-light-txt pl-2" style="background-color: #f9f9f9">
                {{ key }}
              </div>
              <div
                @click="selectFileFormat(i)"
                v-for="i in fileFormatData[key]"
                :key="i.label"
                class="cs-options"
                :class="checkIncludes(i) && 'cs-options-selected'"
              >
                {{ i.label }}
              </div>
            </div>
          </b-collapse>
          <div
            class="errortxt position-absolute"
            v-if="$v.customField.fileFormat.$error"
          >
            Required
          </div>
        </div>

        <!-- PLACEHOLDER TEXT -->
        <div v-if="showPlaceholder" class="position-relative mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="acs-input-head">
              Placeholder Text<span class="asterik">*</span>
            </div>
            <div
              class="cs-greyshadow position-relative"
              @mouseenter="(showTooltipPlace = true), scrollToBottom()"
              @mouseleave="showTooltipPlace = false"
            >
              <img src="../../assets/customfield/greyI.svg" alt="" />
              <div v-if="showTooltipPlace" class="cs-tooltip-place">
                <div class="text-center">
                  <img src="../../assets/customfield/tooltipImg.svg" alt="" />
                </div>
                <div class="mt-1">
                  The placeholder text should indicate<br />
                  to the user what type of data is<br />
                  expected in the field.
                </div>
              </div>
            </div>
          </div>
          <div class="mt-1">
            <b-form-input
              @keyup.enter="addField('customField')"
              :class="{ redError: $v.customField.placeholder.$error }"
              v-model.trim="$v.customField.placeholder.$model"
              class="cs-laptopinput"
              id="input-1"
              placeholder="Enter placeholder text"
            >
            </b-form-input>
          </div>
          <div
            class="errortxt position-absolute"
            v-if="$v.customField.placeholder.$error"
          >
            Required
          </div>
        </div>

        <!-- FIELD CHARACTER LIMIT -->
        <div v-if="showCharLimit" class="position-relative mt-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="acs-input-head">
              Field Char Limit<span class="asterik">*</span>
            </div>
            <div
              class="cs-greyshadow position-relative"
              @mouseenter="showTooltipLimit = true"
              @mouseleave="showTooltipLimit = false"
            >
              <img src="../../assets/customfield/greyI.svg" alt="" />
              <div v-if="showTooltipLimit" class="cs-tooltip-place">
                <div class="mt-1">
                  Set the maximum number of<br />
                  characters allowed for this field
                </div>
              </div>
            </div>
          </div>
          <div class="mt-1">
            <b-form-input
              @keydown="handleLimit"
              @keyup.enter="addField('customField')"
              type="number"
              min="1"
              :class="{ redError: $v.customField.limit.$error }"
              v-model="$v.customField.limit.$model"
              class="cs-laptopinput"
              id="input-1"
              placeholder="e.g. 105"
            >
            </b-form-input>
          </div>
          <div
            class="errortxt position-absolute"
            v-if="$v.customField.limit.$error"
          >
            Required
          </div>
        </div>

        <!-- FILE SIZE FIELD -->
        <div v-if="showFileSizeLimit" class="position-relative mt-3">
          <div class="acs-input-head">
            File Size Limit (MB)<span class="asterik">*</span>
          </div>
          <div class="mt-1">
            <b-form-input
              @keydown="handleLimit"
              @keyup.enter="addField('customField')"
              type="number"
              min="1"
              :class="{ redError: $v.customField.maxFileSize.$error }"
              v-model="$v.customField.maxFileSize.$model"
              class="cs-laptopinput"
              id="input-1"
              placeholder="Enter file size limit"
            >
            </b-form-input>
          </div>
          <div
            class="errortxt position-absolute"
            v-if="$v.customField.maxFileSize.$error"
          >
            Required
          </div>
        </div>
      </div>
      <div
        class="
          d-flex
          align-items-center
          justify-content-end
          border-top
          mt-2
          pt-2
          pr-3
        "
      >
        <b-button
          class="acs-cancelBtn-modal width-87 mr-3 mt-1"
          @click="
            (addNewField = true),
              (predefinedField = false),
              (clearAllData = true),
              clearData(),
              (labelExists = false),
              (labelPreExists = false)
          "
          >Cancel</b-button
        >
        <b-button
          class="acs-addBtn-modal width-87 mt-1"
          @click="
            predefinedField
              ? addField('predefinedField')
              : addField('customField')
          "
          >{{ editField ? "Update" : "Add" }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      definefileformatDrop: false,
      controlTypeDropdown: false,
      clearAllData: false,
      optionExists: {},
      showCustomField: false,
      defineformatDrop: false,
      predefinedField: false,
      showTooltipPlace: false,
      showTooltipLimit: false,
      redError: true,
      predefinedDropdown: false,
      addNewField: true,
      labelExists: false,
      labelPreExists: false,
      loopvar: 8,
      loopvar2: 2,
      initialLabel: null,
      customField: {
        label: null,
        controlType: null,
        placeholder: null,
        mandatory: false,
        limit: null,
        values: [
          { label: "", key: "1", isDefault: false },
          { label: "", key: "2", isDefault: false },
        ],
        maxFileSize: null,
        dateTimeFormat: {},
        fileFormat: [],
      },
      predefined: {
        placeholder: null,
        selectedField: null,
        mandatory: false,
      },
      sortAndFilter: {
        text: {
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
        },

        rich_text_box: {
          sort: false,
          sortType: null,
          filter: false,
          search: false,
        },

        number: {
          sort: true,
          sortType: null,
          filter: false,
          search: true,
        },

        email: {
          sort: true,
          sortType: 1,
          filter: false,
          search: true,
        },

        single_select: {
          sort: true,
          sortType: 1,
          filter: true,
          search: true,
        },

        multi_select: {
          sort: false,
          sortType: null,
          filter: true,
          search: true,
        },

        date: {
          sort: true,
          sortType: 1,
          filter: true,
          search: true,
        },

        boolean: {
          sort: true,
          sortType: 1,
          filter: true,
          search: false,
        },

        upload_file: {
          sort: false,
          sortType: null,
          filter: false,
          search: false,
        },
        multi_text: {
          sort: false,
          sortType: null,
          filter: true,
          search: true,
        },
      },
      dateFormatData: [
        { label: "dd-mm-yyyy", value: "DD-MM-YYYY" },
        { label: "mm-dd-yyyy", value: "MM-DD-YYYY" },
        {
          label: "dd-mm-yyyy hh:mm:ss (e.g. 03-05-2021 05:05:02 AM)",
          value: "DD-MM-YYYY HH:mm:ss",
        },
        {
          label: "mm-dd-yyyy hh:mm:ss (e.g. 03-05-2021 05:05:02 AM)",
          value: "MM-DD-YYYY HH:mm:ss",
        },
        { label: "mm-yyyy (e.g. 03/2021)", value: "MM-YYYY" },
        { label: "yyyy (e.g. 2021)", value: "YYYY" },
        { label: "hh:mm:ss (e.g. 05:05:02 AM)", value: "HH:mm:ss" },
      ],
      fileFormatData: {
        "Image File": [
          { label: "GIF", value: ["GIF"] },
          { label: "JPEG", value: ["JPEG"] },
          { label: "JPG", value: ["JPG"] },
          { label: "PNG", value: ["PNG"] },
          { label: "SVG", value: ["SVG"] },
          { label: "TTF or TIF", value: ["TTF", "TIF"] },
        ],
        "Document File": [
          { label: "PDF", value: ["PDF"] },
          { label: "CSV", value: ["CSV"] },
          { label: "DOC and DOCX", value: ["DOC", "DOCX"] },
          { label: "XLS and XLSX", value: ["XLS", "XLSX"] },
        ],
        Number: [
          { label: "HTML", value: ["HTML"] },
          { label: "TXT", value: ["TXT"] },
        ],
        "Video File": [
          { label: "MP4", value: ["MP4"] },
          { label: "MKV", value: ["MKV"] },
          { label: "Webm", value: ["Webm"] },
          { label: "AVI", value: ["AVI"] },
          { label: "MOV", value: ["MOV"] },
          { label: "FLV", value: ["FLV"] },
          { label: "AVCHD", value: ["AVCHD"] },
        ],
        "Presentation File": [
          { label: "PPT and PPTX", value: ["PPT", "PPTX"] },
          { label: "ODP", value: ["ODP"] },
          { label: "Key", value: ["Key"] },
        ],
        "Audio File": [
          { label: "MPEGA audio (M4A)", value: ["MPEGA audio (M4A)"] },
          { label: "MP3", value: ["MP3"] },
          { label: "WAV", value: ["WAV"] },
        ],
      },
      itemsArray: [
        {
          svg: require("../../assets/customfield/dText.svg"),
          text: "Text",
          value: "text",
        },
        {
          svg: require("../../assets/customfield/dRichText.svg"),
          text: "Rich Text Box",
          value: "rich_text_box",
        },
        {
          svg: require("../../assets/customfield/dNum.svg"),
          text: "Number",
          value: "number",
        },
        {
          svg: require("../../assets/customfield/dMail.svg"),
          text: "Email",
          value: "email",
        },
        {
          svg: require("../../assets/customfield/bDrop.svg"),
          text: "Single Select Dropdown",
          value: "single_select",
        },
        {
          svg: require("../../assets/customfield/bDrop.svg"),
          text: "Multi Select Dropdown",
          value: "multi_select",
        },
        {
          svg: require("../../assets/customfield/bDate.svg"),
          text: "Date and Time",
          value: "date",
        },
        {
          svg: require("../../assets/customfield/bBool.svg"),
          text: "Boolean",
          value: "boolean",
        },
        {
          svg: require("../../assets/customfield/tag.svg"),
          text: "Tags",
          value: "multi_text",
        },
        {
          svg: require("../../assets/customfield/file-plus.svg"),
          text: "File Upload",
          value: "upload_file",
        },
        // Add more items as needed
      ],
    };
  },
  components: {
    draggable,
  },
  validations() {
    return {
      predefined: {
        placeholder: {
          required: requiredIf(() => {
            return (
              this.predefined.selectedField &&
              this.predefined.selectedField.controlType != "boolean" &&
              this.predefined.selectedField.controlType != "upload_file"
            );
          }),
        },
        selectedField: {
          required,
        },
      },
      customField: {
        label: {
          required,
        },
        controlType: {
          required,
        },
        placeholder: {
          required: requiredIf(() => {
            return (
              this.customField.controlType &&
              (this.customField.controlType.value == "text" ||
                this.customField.controlType.value == "rich_text_box" ||
                this.customField.controlType.value == "number" ||
                this.customField.controlType.value == "email" ||
                this.customField.controlType.value == "single_select" ||
                this.customField.controlType.value == "multi_select" ||
                this.customField.controlType.value == "date" ||
                this.customField.controlType.value == "multi_text")
            );
          }),
        },
        limit: {
          required: requiredIf(() => {
            return (
              this.customField.controlType &&
              (this.customField.controlType.value == "text" ||
                this.customField.controlType.value == "rich_text_box" ||
                this.customField.controlType.value == "number" ||
                this.customField.controlType.value == "multi_text" ||
                this.customField.controlType.value == "email")
            );
          }),
        },
        values: {
          label: {
            required: requiredIf(() => {
              return (
                this.customField.controlType &&
                (this.customField.controlType.value == "single_select" ||
                  this.customField.controlType.value == "multi_select")
              );
            }),
          },
        },
        maxFileSize: {
          required: requiredIf(() => {
            return (
              this.customField.controlType &&
              this.customField.controlType.value == "upload_file"
            );
          }),
        },
        dateTimeFormat: {
          required: requiredIf(() => {
            return (
              this.customField.controlType &&
              this.customField.controlType.value == "date"
            );
          }),
        },
        fileFormat: {
          required: requiredIf(() => {
            return (
              this.customField.controlType &&
              this.customField.controlType.value == "upload_file"
            );
          }),
        },
      },
    };
  },
  props: {
    allFields: Array,
    predefinedFields: Array,
    editField: Boolean,
    editData: Object,
    discard: Boolean,
  },
  computed: {
    ...mapGetters(["roles"]),
    checkDropValues() {
      for (const obj of this.customField.values) {
        const value = obj["label"];
        if (!value) {
          return true; // Key is empty in at least one object
        }
      }
      return false;
    },

    showPlaceholder() {
      return (
        this.customField.controlType &&
        (this.customField.controlType.value == "text" ||
          this.customField.controlType.value == "rich_text_box" ||
          this.customField.controlType.value == "number" ||
          this.customField.controlType.value == "email" ||
          this.customField.controlType.value == "single_select" ||
          this.customField.controlType.value == "multi_select" ||
          this.customField.controlType.value == "date" ||
          this.customField.controlType.value == "multi_text")
      );
    },
    showDropdown() {
      return (
        this.customField.controlType &&
        (this.customField.controlType.value == "single_select" ||
          this.customField.controlType.value == "multi_select")
      );
    },
    showDateFormat() {
      return (
        this.customField.controlType &&
        this.customField.controlType.value == "date"
      );
    },
    showCharLimit() {
      return (
        this.customField.controlType &&
        (this.customField.controlType.value == "text" ||
          this.customField.controlType.value == "rich_text_box" ||
          this.customField.controlType.value == "number" ||
          this.customField.controlType.value == "multi_text" ||
          this.customField.controlType.value == "email")
      );
    },
    showFileSizeLimit() {
      return (
        this.customField.controlType &&
        this.customField.controlType.value == "upload_file"
      );
    },
  },
  watch: {
    discard(val) {
      if (val) {
        this.clearData();
        this.labelExists = false;
        this.labelPreExists = false;
        this.predefinedField = false;
        this.addNewField = true;
        this.$emit("afterdiscard", false);
      }
    },
    "customField.values"(val) {
      // this.customField.values = this.customField.values.map(
      //         (obj, index) => {
      //           let keyValue = this.getRandomKey()
      //           return { ...obj, seq: index + 1, key: keyValue };
      //           }// Adding 'key' property with 1-based index
      //       );
      if (val.length == 1) {
        this.optionExists[this.customField.values[0].key] = false;
      }
    },
    "customField.controlType"(oldValue, newValue) {
      if (!this.editField) {
        if (!this.clearAllData && !this.addNewField) {
          if (newValue && oldValue && newValue.value) {
            let nameval = this.customField.label;
            this.clearData();
            // this.labelExists = false;
            this.customField.label = nameval;
          } else if (!oldValue && newValue && newValue.value) {
            this.customField.controlType = newValue;
          }
        }
        this.clearAllData = false;
      }
    },
    editData(val) {
      if (val && this.editField) {
        this.clearData("edit");
        this.labelExists = false;
        this.labelPreExists = false;
        this.addNewField = false;
        if (this.editData.fieldType == "predefinedField") {
          this.predefined = this.editData;
          this.predefined.selectedField = this.editData;
          this.predefinedField = true;
          // this.predefined.placeholder = this.editData.placeholder;
          // this.predefined.limit = this.editData.limit;
          // this.predefined.required = this.editData.required || this.editData.mandatory;
          // this.predefined.selectedField = this.editData;
        } else if (this.editData.fieldType == "customField") {
          this.customField = this.editData;
          this.customField.dateTimeFormat = this.getDateFormat(
            this.customField.dateTimeFormat
          );
          this.customField.controlType = this.getTextAndSvg(
            this.customField.controlType
          );
          this.initialLabel = this.editData.label;
          this.predefinedField = false;
        }
      }
    },
  },
  methods: {
    scrollToBottom() {
      const container = this.$refs.scrollContainer;
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    },
    getSelectedFormatLabels(arr1) {
      let arr = [...arr1];
      // let arr = this.customField.fileFormat
      for (let i in arr) {
        if (arr[i] == "DOC") {
          arr[i] = "DOC and DOCX";
          let ind = arr.indexOf("DOCX");
          arr.splice(ind, 1);
        } else if (arr[i] == "PPT") {
          arr[i] = "PPT and PPTX";
          let ind = arr.indexOf("PPTX");
          arr.splice(ind, 1);
        } else if (arr[i] == "XLS") {
          arr[i] = "XLS and XLSX";
          let ind = arr.indexOf("XLSX");
          arr.splice(ind, 1);
        } else if (arr[i] == "TTF") {
          arr[i] = "TTF and TIF";
          let ind = arr.indexOf("TIF");
          arr.splice(ind, 1);
        }
      }
      return arr.join(" + ");
    },
    checkIncludes(i) {
      return i.value.every((element) =>
        this.customField.fileFormat.includes(element)
      );
    },
    handleLimit(event) {
      const restrictedChars = ["+", "-"];
      // Check if the pressed key is in the restricted characters list
      if (restrictedChars.includes(event.key)) {
        event.preventDefault();
      }
      if (
        event.key == 0 &&
        !this.customField.maxFileSize &&
        !this.customField.limit
      ) {
        event.preventDefault();
      }
      if (event.key === "Backspace") {
        return;
      }
      if (event.key === "e" || isNaN(event.key)) {
        event.preventDefault();
      }
    },
    checkDuplicateOpt() {
      for (var key in this.optionExists) {
        if (this.optionExists[key] == true) {
          return true;
        }
      }
      return false;
    },
    checkOptionExists() {
      for (let i in this.customField.values) {
        this.optionExists[this.customField.values[i].key] =
          this.customField.values.some(
            (obj) =>
              obj.key != this.customField.values[i].key &&
              obj.label.toLowerCase().trim() ==
                this.customField.values[i].label.toLowerCase().trim()
          );
      }
      // for(let i in this.customField.values){
      //   this.optionExists[this.customField.values[i].key] = false;
      // }
      // this.optionExists[val.key] = this.customField.values.some(obj =>  obj.key != val.key && obj.label.toLowerCase().trim() == val.label.toLowerCase().trim())
    },
    checkExists() {
      if (this.customField.label) {
        this.labelExists = this.editField
          ? this.allFields.some(
              (obj) =>
                obj.label != this.initialLabel &&
                obj.label.toLowerCase().trim() ==
                  this.customField.label.toLowerCase().trim()
            )
          : this.allFields.some(
              (obj) =>
                obj.label.toLowerCase().trim() ==
                this.customField.label.toLowerCase().trim()
            );

        this.labelPreExists = this.editField
          ? this.predefinedFields.some(
              (obj) =>
                obj.label != this.initialLabel &&
                obj.label.toLowerCase().trim() ==
                  this.customField.label.toLowerCase().trim()
            )
          : this.predefinedFields.some(
              (obj) =>
                obj.label.toLowerCase().trim() ==
                this.customField.label.toLowerCase().trim()
            );
      }
    },
    changeDefaultValues(val, defval) {
      if (defval) {
        for (let i in this.customField.values) {
          if (this.customField.values[i].key != val) {
            this.customField.values[i].isDefault = false;
          }
        }
      }
    },
    selectFileFormat(i) {
      for (let j of i.value) {
        let ind = this.customField.fileFormat.indexOf(j);
        if (ind != -1) {
          this.customField.fileFormat.splice(ind, 1);
        } else {
          this.customField.fileFormat.push(j);
        }
      }
    },
    getDateFormat(value) {
      for (const item of this.dateFormatData) {
        if (item.value === value) {
          return { label: item.label, value: value };
        }
      }
      return { label: "", value: "" }; // Default values if value not found
    },
    getTextAndSvg(value) {
      for (const item of this.itemsArray) {
        if (item.value === value) {
          return { text: item.text, svg: item.svg, value: value };
        }
      }
      return { text: "", svg: "" }; // Default values if value not found
    },
    getRandomKey() {
      const charset =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let key = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        key += charset[randomIndex];
      }
      return key;
    },
    removeFromDropdown(obj) {
      delete this.optionExists[obj.key];
      this.customField.values = this.customField.values.filter(
        (value) => value.key != obj.key
      );
    },
    addDropdown() {
      let newValue = {
        label: "",
        key: this.getRandomKey(),
        isDefault: false,
      };
      this.customField.values.push(newValue);
    },
    generateKey(type, label) {
      let key =
        type.toUpperCase() +
        "_" +
        this.$route.query.id +
        "_" +
        label.replace(/ /g, "_") +
        "_" +
        this.getRandomKey();
      return key;
    },
    generateKeyForDrop(mainLabel, label) {
      return (
        "DROPDOWN_CUSTFIELD_" +
        this.$route.query.id +
        "_" +
        mainLabel.replace(/ /g, "_") +
        "_" +
        this.getRandomKey() +
        "_" +
        label.replace(/ /g, "_") +
        "_" +
        this.getRandomKey()
      );
    },
    assignSortAndFilter(fieldData) {
      const fieldType = fieldData.controlType;
      if (this.sortAndFilter[fieldType] !== undefined) {
        const { sort, sortType, filter, search } =
          this.sortAndFilter[fieldType];
        fieldData.sort = sort;
        fieldData.sortType = sortType;
        fieldData.filter = filter;
        fieldData.search = search;
      }
    },
    addField(type) {
      if (type == "predefinedField") {
        this.$v.predefined.$touch();
        if (!this.$v.predefined.$invalid) {
          this.predefined.controlType =
            this.predefined.selectedField.controlType;
          this.predefined.label = this.predefined.selectedField.label;
          this.predefined.key = this.predefined.selectedField.key;
          this.predefined.values = !this.predefined.selectedField.values
            ? []
            : this.predefined.selectedField.values;

          this.predefined.fieldType = type;
          this.predefined.hide = false;
          // this.predefined.values = !this.predefined.values
          //   ? []
          //   : this.predefined.values;
          this.predefined.apiEndpoint = this.predefined.selectedField
            .apiEndpoint
            ? this.predefined.selectedField.apiEndpoint
            : null;
          this.predefined.dropdown = !this.predefined.selectedField.dropdown
            ? false
            : this.predefined.selectedField.dropdown;
          this.predefined.multi = !this.predefined.selectedField.multi
            ? false
            : this.predefined.selectedField.multi;
          if (this.predefined.selectedField.multi) {
            this.predefined.dropdown = true;
          }
          this.predefined.dateTimeFormat = !this.predefined.selectedField
            .dateTimeFormat
            ? null
            : this.predefined.selectedField.dateTimeFormat;
          this.predefined.fileFormat = !this.predefined.selectedField.fileFormat
            ? null
            : this.predefined.selectedField.fileFormat;

          this.predefined.limit = !this.predefined.selectedField.limit
            ? null
            : parseInt(this.predefined.selectedField.limit);
          this.predefined.maxFileSize = !this.predefined.selectedField
            .maxFileSize
            ? null
            : this.predefined.selectedField.maxFileSize;
          if (this.predefined.selectedField.child) {
            this.predefined.child = this.predefined.selectedField.child;
          }
          delete this.predefined.selectedField;
          this.assignSortAndFilter(this.predefined);

          this.$emit("addToFields", this.predefined);
          this.predefinedField = false;
          this.addNewField = true;
          this.clearData();
          this.labelExists = false;
          this.labelPreExists = false;
        }
      }
      if (type == "customField") {
        this.$v.customField.$touch();
        let condition =
          this.customField.controlType &&
          (this.customField.controlType.value == "single_select" ||
            this.customField.controlType.value == "multi_select")
            ? !this.$v.customField.label.$invalid &&
              !this.$v.customField.controlType.$invalid &&
              !this.$v.customField.placeholder.$invalid &&
              !this.checkDropValues &&
              !this.labelExists &&
              !this.labelPreExists &&
              !this.checkDuplicateOpt()
            : !this.$v.customField.$invalid &&
              !this.labelExists &&
              !this.labelPreExists;
        if (condition) {
          this.customField.dateTimeFormat =
            this.customField.dateTimeFormat &&
            Object.keys(this.customField.dateTimeFormat).length == 0
              ? null
              : this.customField.dateTimeFormat.value;
          this.customField.key = !this.editField
            ? this.generateKey("CUSTFIELD", this.customField.label)
            : this.customField.key;
          this.customField.fieldType = type;
          this.customField.hide = false;
          this.customField.controlType = this.customField.controlType.value;
          this.customField.values =
            this.customField.controlType != "single_select" &&
            this.customField.controlType != "multi_select"
              ? []
              : this.customField.values;
          this.customField.dropdown =
            this.customField.controlType == "single_select" ||
            this.customField.controlType == "multi_select"
              ? true
              : false;
          this.customField.multi =
            this.customField.controlType == "multi_select" ? true : false;
          this.customField.apiEndpoint = this.customField.apiEndpoint
            ? this.customField.apiEndpoint
            : null;
          this.customField.limit = !this.customField.limit
            ? null
            : parseInt(this.customField.limit);
          if (this.customField.values.length != 0) {
            this.customField.values = this.customField.values.map(
              (obj, index) => {
                if (!obj.key.startsWith("DROPDOWN")) {
                  let keyValue = this.generateKeyForDrop(
                    this.customField.label,
                    obj.label
                  );
                  return { ...obj, seq: index + 1, key: keyValue };
                } else {
                  return { ...obj, seq: index + 1, key: obj.key };
                }
                // Adding 'key' property with 1-based index
              }
            );
          }
          this.assignSortAndFilter(this.customField);
          this.customField.apiEndpoint = "";
          this.$emit("addToFields", this.customField);
          this.predefinedField = false;
          this.addNewField = true;
          this.clearData();
          this.labelExists = false;
          this.labelPreExists = false;
          // this.predefined.selectedField.fieldType = type;
          // this.predefined.selectedField.placeholder = this.predefined.placeholder;
          // this.predefined.selectedField.limit = this.predefined.limit;
          // this.predefined.selectedField.mandatory = this.predefined.required;
          // this.$emit('addToFields', this.predefined.selectedField);
          // this.predefinedField =  false;
          // this.addNewField = true;
          // this.clearData();
        }
      }
    },
    clearData(val) {
      if (!val) {
        this.$emit("changeEdit", false);
      }
      this.$v.$reset();
      this.initialLabel = null;
      this.optionExists = {};
      this.predefined = {
        placeholder: null,
        mandatory: false,
        selectedField: null,
      };
      this.customField = {
        label: null,
        controlType: null,
        placeholder: null,
        mandatory: false,
        limit: null,
        values: [
          { label: "", key: "1", isDefault: false },
          { label: "", key: "2", isDefault: false },
        ],
        maxFileSize: null,
        dateTimeFormat: {},
        fileFormat: [],
      };
    },
    hideFileFormatDropdown() {
      this.definefileformatDrop = false;
    },
    hideDateFormatDropdown() {
      this.defineformatDrop = false;
    },
    hideControlDropdown() {
      this.controlTypeDropdown = false;
    },
    hidePredefinedDropdown() {
      this.predefinedDropdown = false;
    },
    capitalize(text) {
      return text.replace(
        /(?:^|_)([a-z])/g,
        (match, char) => " " + char.toUpperCase()
      );
    },
  },
};
</script>

<style scoped>
.padding-12-15 {
  padding: 12px 15px;
}
</style>
